// Import model
import { EstimateOptionsCondition } from '../models/EstimateOptionsCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { EstimateOptionsIndexedFields } from '../models/EstimateOptionsIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { EstimateOptionsIndexedFieldsSerializer } from './EstimateOptionsIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for EstimateOptionsCondition - handles JSON serialization and deserialization with type validation
 */
export class EstimateOptionsConditionSerializer {
  /**
   * Deserializes a JSON string into a EstimateOptionsCondition instance
   */
  static deserialize(json: string): EstimateOptionsCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a EstimateOptionsCondition instance
   */
  static fromObject(obj: any): EstimateOptionsCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to EstimateOptionsCondition');
    }


    const instance: EstimateOptionsCondition = {
      fieldName: obj['fieldName'] as EstimateOptionsIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of EstimateOptionsCondition instances
   */
  static deserializeArray(json: string): EstimateOptionsCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a EstimateOptionsCondition instance to a JSON string
   */
  static serialize(instance: EstimateOptionsCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a EstimateOptionsCondition instance to a plain object
   */
  static toObject(instance: EstimateOptionsCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of EstimateOptionsCondition instances to a JSON string
   */
  static serializeArray(instances: EstimateOptionsCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
